import { StyleThemeEnums } from '@gif/shared-global';

export const isLightTheme = (theme: any) => theme.id === StyleThemeEnums.LIGHT;

export const isDarkTheme = (theme: any) => theme.id === StyleThemeEnums.DARK;
